import { Routes } from '@angular/router'

import { DefaultApplicationPermissionsGuard } from '@flowx/designer/shared/guards/application-permissions.guards'
import { LayoutOptions } from '@flowx/designer/shared/types/layout.types'

import { UiFlowRunningInstanceComponent } from './pages/ui-flow-running-instance/ui-flow-running-instance.component'

export const UiFlowInstanceRoutes: Routes = [
  {
    path: ':uiFlowResourceId/instance',
    component: UiFlowRunningInstanceComponent,
    canActivate: [DefaultApplicationPermissionsGuard('ui_flow_read')],
    data: {
      [LayoutOptions.HAS_TOP_BANNER]: false,
      [LayoutOptions.IS_RUNNING_INSTANCE]: true,
    },
    children: [
      {
        path: 'workflow-instances',
        loadChildren: () =>
          import(
            '@flowx/designer/modules/integration-designer/workflow-integration/workflow-instances-routes'
          ).then((m) => m.workflowInstancesRoutes),
        outlet: 'workflowInstances',
      },
    ],
  },
]
